<div [hidden]="!showAptReq" class="bg-white shadow-lg" style="position: fixed; right: 0px; top: 0px; height: 100%; width: 400px; max-width: 100% !important; z-index: 1039; overflow-y: scroll !important">
  <h3 class="border-bottom p-3 font-weight-normal sticky-top bg-white">
    <a class="text-dark font-weight-light float-right" style="cursor: pointer" (click)="$event.preventDefault(); $event.stopImmediatePropagation(); closeSidebar()">
      <span class="ti-close"></span>
    </a>
    Appointment Requests
  </h3>
  <div class="p-3">
    <table class="table table-sm" *ngIf="appointmentRequestsToView">
      <tbody>
        <tr *ngFor="let ar of appointmentRequestsToView">
          <td>
            <div class="float-right" title="ASAP" *ngIf="ar.asap">
              <i class="fas fa-clock text-warning"></i>
            </div>
            <a (click)="closeSidebar()" title="View Apt Req" [routerLink]="'/matters/' + ar.matter_id + '/appointment_requests/' + ar.id">{{ ar.status }}</a>
            <br />
            By&nbsp;{{ ar.created_by_name }}
            <br />
            {{ ar.pre_notes }}
            <br />
            <a [routerLink]="'/matters/' + ar.matter_id" [title]="ar.matter_name">{{ ar.truncated_matter_name }}</a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
